module.exports = __webpack_public_path__ + "static/media/product-banner.889a5577.png";